/**
 * sessionConfig.ts
 *
 * Fallback defaults for session-management timeouts.
 * IDLE_TIMEOUT_MS and IDLE_WARNING_BEFORE_MS are overridden at runtime by the
 * backend-supplied values in state.cache.frontend (keys "application.idle.timeout"
 * and "application.idle.warning", in seconds). useSessionConfig performs that
 * lookup and falls back to the constants below.
 */

// ── Idle timeout fallback defaults ────────────────────────────────────────────

/** Fallback: 30 minutes. Overridden by cache key "application.idle.timeout". */
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

/** Fallback: 5 minutes. Overridden by cache key "application.idle.warning". */
export const IDLE_WARNING_BEFORE_MS = 5 * 60 * 1000;

/**
 * How long the courier handover scan page may be inactive before its warning
 * modal appears (ms). Default: 5 minutes.
 */
export const HANDOVER_INACTIVITY_MS = 5 * 60 * 1000;

// ── Activity detection ─────────────────────────────────────────────────────────

/**
 * Leading-edge throttle interval for user-activity events (ms).
 * Prevents the idle timer from being reset on every pixel of mouse movement.
 * Default: 1 second.
 */
export const ACTIVITY_THROTTLE_MS = 1000;

// ── Cross-tab synchronisation ─────────────────────────────────────────────────

/**
 * BroadcastChannel name shared across all tabs of the same origin.
 */
export const SESSION_BROADCAST_CHANNEL = 'rwf-session';

// ── Broadcast message types ───────────────────────────────────────────────────

export type SessionBroadcastMessage = { type: 'logout' } | { type: 'refresh' };
